import * as yup from 'yup';

import { PRODUCT_NAMES } from './products';

export const productValidationSchema = yup.object({
  [PRODUCT_NAMES.PRODUCT_ID]: yup.string(),
  [PRODUCT_NAMES.NAME]: yup.string(),
  [PRODUCT_NAMES.PRICE]: yup.string(),
  [PRODUCT_NAMES.VOLUME_UNITS]: yup.string(),
  [PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL]: yup.string(),
  [PRODUCT_NAMES.MONTHLY_SALES_PLAN_MONETARY]: yup.string(),
  [PRODUCT_NAMES.ANNUAL_PRICE_GROWTH_RATE]: yup.string(),
  [PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE]: yup.string(),
  [PRODUCT_NAMES.ANNUAL_EXPENSE_GROWTH]: yup.string(),
  [PRODUCT_NAMES.COST_PER_UNIT]: yup.string(),
});
